import { useEffect, useState } from "react";
import { shouldReduceMotion } from "../utils/motion";

const usePrefersReducedMotion = () => {
  const [reduced, setReduced] = useState(shouldReduceMotion);

  useEffect(() => {
    if (!window.matchMedia) return undefined;

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handleChange = () => setReduced(mediaQuery.matches);

    handleChange();
    mediaQuery.addEventListener("change", handleChange);

    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return reduced;
};

export default usePrefersReducedMotion;
